import { render, staticRenderFns } from "./AllCandidates.vue?vue&type=template&id=2a579a2a&scoped=true"
import script from "./AllCandidates.vue?vue&type=script&lang=js"
export * from "./AllCandidates.vue?vue&type=script&lang=js"
import style0 from "./AllCandidates.vue?vue&type=style&index=0&id=2a579a2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a579a2a",
  null
  
)

export default component.exports